/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */
import React from "react";
import CustomLink from "components/Links/CustomLink";

import useTranslation from "next-translate/useTranslation";
import Chip from "@mui/material/Chip";
//import TouchableTooltip from 'components/Tooltip/TouchableTooltip';
import Tooltip from "@mui/material/Tooltip";
import handleTermChoice from "modules/products/handleTermChoice";

import PropTypes from "prop-types";

import { BreadcrumbJsonLd } from "next-seo";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
import { ROOT_URL } from "settings/global-urls";

import SkeletonWithFade from "components/Loading/SkeletonWithFade";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  block: {
    marginTop: theme.spacing(0.5),
    display: "inline-block",
    "& a": {
      color: theme.palette.primary.main,
    },
  },
  chip: {
    margin: theme.spacing(0, 0.5),
    borderRadius: theme.shape.borderRadius,
  },
  icon: {
    width: 20,
    height: 20,
    verticalAlign: "middle",
    marginBottom: theme.spacing(0.25),
    cursor: "pointer",
  },
}));

export default function BreadcrumbsModule(props) {
  const {
    breadcrumbsHierarchy,
    currentItem,
    path,
    pageTransition,
    chipsLoading,
    handleFilterUpdate,
    hideBase,
  } = props;

  const { t } = useTranslation();

  function getName(level) {
    if (level.translateName) {
      return t(`feeds:${level.name}`);
    }
    return level.name;
  }

  const breadcrumbJson = [
    {
      position: 1,
      name: "Home",
      item: ROOT_URL,
    },
  ];

  if (!pageTransition && breadcrumbsHierarchy) {
    for (let i = 0, { length } = breadcrumbsHierarchy; i < length; i += 1) {
      // don't add a breadcrumb if there are multiple terms at that level

      const as = breadcrumbsHierarchy[i].loading
        ? null
        : breadcrumbsHierarchy[i].as ||
          (breadcrumbsHierarchy[i].href !== "termTags" &&
            breadcrumbsHierarchy[i].href) ||
          (breadcrumbsHierarchy[i].ass && breadcrumbsHierarchy[i].ass[0]);

      if (
        as &&
        as !== path &&
        (!breadcrumbsHierarchy[i].names ||
          breadcrumbsHierarchy[i].names?.length <= 1)
      ) {
        breadcrumbJson.push({
          position: breadcrumbJson.length + 1,
          name: breadcrumbsHierarchy[i].loading
            ? null
            : getName(breadcrumbsHierarchy[i]) ||
              breadcrumbsHierarchy[i].names?.[0],
          item: ROOT_URL + as,
        });
      }
    }
    if (path) {
      breadcrumbJson.push({
        position: breadcrumbJson.length + 1,
        name: currentItem,
        item: ROOT_URL + path,
      });
    }
  }
  const { classes } = useStyles();

  const hierarchyToUse = breadcrumbsHierarchy || [
    {
      loading: true,
    },
    {
      loading: true,
    },
    {
      loading: true,
    },
  ];

  const breadcrumbsItems = hierarchyToUse
    .filter((level) => !hideBase || level.clickType === "filter")
    .map((level) =>
      (chipsLoading && level.terms?.length) || level.loading ? (
        <SkeletonWithFade
          key={`link-loading-${level.position}`}
          inProp
          width="80px"
          height={chipsLoading && level.terms?.length ? "24px" : ""}
        />
      ) : level.clickType !== "filter" ? (
        <CustomLink key={`link-${level.href}`} href={level.href}>
          {getName(level)}
        </CustomLink>
      ) : (
        level.terms?.length > 0 && (
          <div key={`link-${level.href}`}>
            {level.terms.map((term) => (
              <Tooltip
                key={term.uri}
                id={`${term.node.slug}-tooltip`}
                title={level.title}
              >
                <Chip
                  size="small"
                  label={term.node.name}
                  color="primary"
                  classes={{ root: classes.chip }}
                  onDelete={
                    /* isTouchDevice
                    ? false
                    :*/ () =>
                      handleTermChoice(
                        handleFilterUpdate,
                        term.filterSpecificDetails.onClickUri,
                        term.filterSpecificDetails.onClickQueryType,
                        term
                      )
                  }
                />
              </Tooltip>
            ))}
          </div>
        )
      )
    );

  return (
    <div className={classes.block} key={`breadcrumb-fragment-${path}`}>
      <Breadcrumbs
        separator={hideBase ? <span /> : <NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        itemsAfterCollapse={3}
        key={`breadcrumb-component-${path}`}
      >
        {!hideBase && (
          <CustomLink href="/" aria-label={t("nav:home")} legacyBehavior>
            <HomeIcon className={classes.icon} />
          </CustomLink>
        )}
        {breadcrumbsItems}
      </Breadcrumbs>

      {!pageTransition ? (
        <BreadcrumbJsonLd itemListElements={breadcrumbJson} />
      ) : null}
    </div>
  );
}

BreadcrumbsModule.propTypes = {
  featuredImage: PropTypes.object,
  href: PropTypes.string,
  as: PropTypes.string,
};
